import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";
import About from "../Sections/home/About";
import Contact from "../Sections/home/Contact";
import Features from "../Sections/home/Features";
import Jumbotron from "../Sections/home/Jumbotron";
import Portfolio from "../Sections/home/Portfolio";
import Services from "../Sections/home/Services";
import Skills from "../Sections/home/Skills";
import Team from "../Sections/home/Team";
import Testimonial from "../Sections/home/Testimonial";

export default function Home(){
    const { data: {home} } = useGetSettingQuery()

    return (
        <>
           {home.jumbotron && <Jumbotron/>}
           {home.skills && <Skills/>}
           {home.about && <About/>}
           {home.services && <Services/>}
           {home.features && <Features/>}
           {home.portfolio && <Portfolio/>}
           {home.contact && <Contact/>}
           {home.team && <Team/>}
           {home.testimonial && <Testimonial/>}
        </>
    )
}